import { z } from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const SpecAreaCodeEnum = z.string();
export type SpecAreaCode = LooseAutocomplete<
  'ANKLE-FOOT' | 'ELBOW' | 'HIP' | 'KNEE' | 'LOWER-BACK' | 'MID-BACK' | 'MULTI' | 'NECK' | 'SHOULDER' | 'WRIST-HAND'
>;
